import { DateTime } from "luxon";
import React from "react";
import * as Yup from "yup";
import { TFunction } from "i18next";

export const renderScheduleStatus = (isScheduleActive: boolean, missed: string, installed: string) => {
    const statusClassName = isScheduleActive
        ? "outline-green text-green border border-green"
        : "outline-orange text-orange border border-orange";

    return (
        <div className={`${statusClassName} w-100 h-100 p-1 text-center rounded fs-7`}>
            {isScheduleActive ? installed : missed}
        </div>
    );
};

export const getNextDay = (dateString: string): string => {
    return DateTime.fromISO(dateString).plus({ days: 1 }).toISODate();
};

export const deleteEmployeeModalValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        endOfCooperation: Yup.string().required(t("End date of cooperation is mandatory")),
        reasonId: Yup.number().required(t("Please select a reason")),
        comment: Yup.string()
            .max(200, t("Comment cannot exceed 200 characters"))
            .when("reasonId", {
                is: 4,
                then: (schema) => schema.required(t("Explain the reason for dismissal")),
                otherwise: (schema) => schema.nullable(),
            }),
    });
